var map = {
	"./comments.svg": 776,
	"./copy-link.svg": 749,
	"./facebook.svg": 827,
	"./like-fill.svg": 774,
	"./like.svg": 775,
	"./ok.svg": 828,
	"./share.svg": 777,
	"./telegram.svg": 829,
	"./twitter.svg": 830,
	"./vk.svg": 831,
	"./whatsapp.svg": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;